import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../state/auth-state';
import { Button } from '../components/ui/button';
import { Alert, AlertDescription } from '../components/ui/alert';

/**
 * Login page — redirects authenticated users, shows login button for unauthenticated.
 * Uses EntraID OAuth2 Authorization Code flow.
 */
export function LoginPage(): React.JSX.Element {
  const { state, login } = useAuth();

  // If already authenticated, redirect to home
  if (state.isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="w-full max-w-sm space-y-6 p-6">
        <div className="space-y-2 text-center">
          <h1 className="text-2xl font-bold text-foreground">DelegatedDNS</h1>
          <p className="text-sm text-muted-foreground">
            Sign in with your organization account to manage DNS records.
          </p>
        </div>

        {state.error && (
          <Alert variant="destructive">
            <AlertDescription>{state.error}</AlertDescription>
          </Alert>
        )}

        <Button onClick={login} className="w-full" size="lg">
          Sign in with EntraID
        </Button>
      </div>
    </div>
  );
}
